export default "__VITE_ASSET__BTnWQEk2__"